// Badge mute mostrato sotto un messaggio quando l'encounter è non-IT ma la
// traduzione IT è mancante per quel singolo turno (Haiku ha fallito).
// Onesto sull'assenza, niente bottone "riprova" — il backfill è idempotente
// e rieseguito al prossimo refresh della pagina.

export interface MissingTranslationBadgeProps {
  inverse?: boolean;
}

export function MissingTranslationBadge({ inverse }: MissingTranslationBadgeProps) {
  const className = inverse
    ? 'audiq-missing-translation audiq-missing-translation--inverse'
    : 'audiq-missing-translation';
  return <span className={className}>ⓘ traduzione non disponibile</span>;
}
